<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">优惠券名称：</span>
        </div>
        <el-input v-model="formData.name" size="small" style="width: 280px" />
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">优惠券类型：</span>
        </div>
        <el-select v-model="formData.type" size="small" style="width: 280px">
          <el-option v-for="item in typeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">优惠券面额：</span>
        </div>
        <el-input v-if="formData.type === '金额'" v-model="formData.denominationMoney" size="small" style="width: 280px">
          <template slot="append">元</template>
        </el-input>
        <el-input v-if="formData.type === '时长'" v-model="formData.denominationHour" size="small" style="width: 140px" >
          <template slot="append">小时</template>
        </el-input>
        <el-input v-if="formData.type === '时长'" v-model="formData.denominationMinite" size="small" style="width: 140px" >
          <template slot="append">分钟</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">优惠券张数：</span>
        </div>
        <el-input v-model="formData.num" size="small" style="width: 280px">
          <template slot="append">张</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">优惠券售价：</span>
        </div>
        <el-input v-model="formData.price" size="small" style="width: 280px">
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">用户可自购
            <el-tooltip class="item" effect="dark" placement="top-start">
              <div slot="content">是否允许用户在小程序端自行购买优惠券</div>
              <i class="el-icon-question"></i>
            </el-tooltip>：
          </span>
        </div>
        <el-switch v-model="formData.saleForMobile" active-text="是" inactive-text="否"></el-switch>
      </div>
      <div class="form-line">
        <div class="textBox">
<!--          <b class="red">*</b>-->
          <span class="line-text">优惠券有效期：</span>
        </div>
        <el-date-picker v-model="couponTimeValue" size="small" type="datetimerange"
                        :picker-options="pickerOptions2" range-separator="至"
                        start-placeholder="起始日期" end-placeholder="截止日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {api} from '../../../api/ParkingService'
  import {errorHandler} from '../../../../utils/errorHandler'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {pattern} from '../../../../utils/regular'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'coupon-put-on-the-shelves-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧停车',
          name: 'parking-device-management'
        }, {
          value: '上架优惠券'
        }],
        mainTitle: '修改上架优惠券',
        subheading: '',
        pickerOptions2: {
          shortcuts: [{
            text: '未来一年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来三年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 3)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '未来五年',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 5)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        typeList: [
          { code: '金额', name: '金额' },
          { code: '时长', name: '时长' },
        ],
        couponTimeValue: [],
        formData: {
          code: '',
          name: '',
          type: '',
          denominationMoney: '',
          denominationHour: '',
          denominationMinite: '',
          num: '',
          price: '',
          startTime: '',
          endTime: '',
          saleForMobile: false
        }
      }
    },
    created () {
      this.formData.code = this.$route.params.id
      this.parkingCouponIssueGetByCode()
    },
    methods: {
      parkingCouponIssueGetByCode () {
        this.$axios.get(`${api.parkingCouponIssueGetByCode}/${this.formData.code}`, {})
          .then(res => {
            let data = res.data.data
            this.formData = data
            if (data.startTime && data.endTime) {
              this.couponTimeValue = [data.startTime, data.endTime]
            }
          })
          .catch(errorHandler('获取数据失败'))
      },
      toMangePage () {
        this.$router.push({
          name: 'coupon-put-on-the-shelves'
        })
      },
      // 确认修改
      confirm () {
        if (!this.formData.name) {
          nError('请输入优惠券名称')
          return false
        }
        if ((this.formData.type === '金额' && !this.formData.denominationMoney) || (this.formData.type === '时长' && (!this.formData.denominationHour && !this.formData.denominationMinite))) {
          nError('请输入优惠券面额')
          return false
        }
        if (!this.formData.num) {
          nError('请输入优惠券张数')
          return false
        }
        if (!this.formData.price) {
          nError('请输入优惠券售价')
          return false
        }
        // if (!this.formData.startTime || !this.formData.endTime) {
        //   nError('请输入优惠券有效期')
        //   return false
        // }
        this.$axios.post(api.parkingCouponIssueUpdate, this.formData)
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              this.toMangePage()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      cancel () {
        this.toMangePage()
      }
    },
    watch: {
      'formData.type': {
        handler(newName, oldName) {
          if (this.formData.type === '金额') {
            this.denominationHour = ''
            this.denominationMinite = ''
          } else if (this.formData.type === '时长') {
            this.denominationMoney = ''
          }
        },
        deep: true
      },
      couponTimeValue (val) {
        if (this.couponTimeValue) {
          this.formData.startTime = this.couponTimeValue[0] || ''
          this.formData.endTime = this.couponTimeValue[1] || ''
        } else {
          this.formData.startTime = ''
          this.formData.endTime = ''
        }
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 180px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingCoupon/CouponPutOnTheShelves/CouponPutOnTheShelvesModify.vue